import { render, staticRenderFns } from "./typography-title.vue?vue&type=template&id=7eca6428&scoped=true&"
import script from "./typography-title.vue?vue&type=script&lang=js&"
export * from "./typography-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eca6428",
  null
  
)

export default component.exports